import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {FormControl} from '@angular/forms';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'app-report-test',
  templateUrl: './report-test.component.html',
  styleUrls: ['./report-test.component.css'],
   providers: [HelperService] 
})
export class ReportTestComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
 from;
 to;
 datas:any=[];
 dtOptions: any = {};
 dtTrigger: Subject<any> = new Subject();
  dtElement: DataTableDirective;
  start_date;
 end_date;
 user_permissions:any=[];
 student_id;
 user_token= localStorage.getItem('access_token');
 private headers: Headers = new Headers({
 'Accept': 'application/json',
 'Authorization': "Bearer "+this.user_token
});
 constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) {
  	
  		activatedRouter.queryParams.subscribe(params => {
    this.from = params['from'];
    this.to = params['to'];
    this.student_id = params['student_id'];
    if(this.from!=0){
       this.start_date  = new Date(Date.parse(this.from));
      
     this.end_date = new Date(Date.parse(this.to));
     
    }
});
     
  		
  }


  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
  	this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      order : [],
      dom: 'Bfrtip',
      buttons: [
        {
          extend: "excel",
          filename:  "ChapterTestReport",
          exportData: { decodeEntities: true }
      },
      {
          extend: "csv",
          filename:  "ChapterTestReport",
          exportOptions: {
              columns: ':visible'
          },
          exportData: {decodeEntities:true}
      }
        //  'csv','pdf','excel'
        ]    
    };
    
    this.http.get(this.helper.base_url+'http/get/report?type=test&from='+this.from+'&to='+this.to+'&student_id='+this.student_id,{ headers: this.headers })
      
      .subscribe(data => {
        this.datas = JSON.parse(data['_body']);
        
          this.dtTrigger.next();
        
       
      });
  }
   startEvent(type: string, event: MatDatepickerInputEvent<Date>) {
  
   let d1 = new Date(Date.parse(this.start_date));
   let start_date = d1.getFullYear()+"-"+(d1.getMonth()+1)+"-"+d1.getDate();

   let d2 = new Date(Date.parse(this.end_date));
   let end_date = d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+d2.getDate();


   if(end_date!="NaN-NaN-NaN" && start_date!="NaN-NaN-NaN"){
    let sDate = new Date(start_date);
    let eDate = new Date(end_date);

    if(sDate<=eDate){
      this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
   this.router.navigate(['reports/tests'], { queryParams: { from: start_date,to: end_date } }));
     
    }
   }
   
  }
  endEvent(type: string, event: MatDatepickerInputEvent<Date>) {
 
   let d1 = new Date(Date.parse(this.start_date));
   let start_date = d1.getFullYear()+"-"+(d1.getMonth()+1)+"-"+d1.getDate();

   let d2 = new Date(Date.parse(this.end_date));
   let end_date = d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+d2.getDate();


    if(end_date!="NaN-NaN-NaN" && start_date!="NaN-NaN-NaN"){
    let sDate = new Date(start_date);
    let eDate = new Date(end_date);

    if(sDate<=eDate){
        this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
        this.router.navigate(['reports/tests'], { queryParams: { from: start_date,to: end_date } }));
    }


   }
 
  }

}



// WEBPACK FOOTER //
// ./src/app/report-test/report-test.component.ts